/**
 * The seven battalion funds, seeded by the database seeder.
 *
 * Display order is locked by the CO:
 *   1. Private Fund (dashboard spotlight)
 *   2. Public Fund
 *   3. Regimental Fund
 *   4. Imprest Fund
 *   5. Field Mess
 *   6. Canteen
 *   7. Helmet Fund
 *
 * The CO can add more funds via Settings; renaming or removing one of these
 * seven requires explicit CO approval.
 */

export const FundCode = {
  PVT: 'PVT',
  PUB: 'PUB',
  REG: 'REG',
  IMP: 'IMP',
  FM: 'FM',
  CAN: 'CAN',
  HF: 'HF',
} as const;

export type FundCode = (typeof FundCode)[keyof typeof FundCode];

export interface FundDefinition {
  code: FundCode;
  name: string;
  description: string;
  displayOrder: number;
}

export const FUND_DEFINITIONS: readonly FundDefinition[] = [
  {
    code: FundCode.PVT,
    name: 'Private Fund',
    description: 'CO’s discretionary private fund. Dashboard Row 1 spotlight.',
    displayOrder: 1,
  },
  {
    code: FundCode.PUB,
    name: 'Public Fund',
    description: 'Operational and administrative expenditure of the unit.',
    displayOrder: 2,
  },
  {
    code: FundCode.REG,
    name: 'Regimental Fund',
    description: 'Sports, recreation, welfare, and unit functions.',
    displayOrder: 3,
  },
  {
    code: FundCode.IMP,
    name: 'Imprest Fund',
    description: 'Small operational cash float for day-to-day requirements.',
    displayOrder: 4,
  },
  {
    code: FundCode.FM,
    name: 'Field Mess',
    description: 'Officers’ / JCOs’ mess provisions and running costs.',
    displayOrder: 5,
  },
  {
    code: FundCode.CAN,
    name: 'Canteen',
    description: 'Unit canteen inventory, salaries, and running costs.',
    displayOrder: 6,
  },
  {
    code: FundCode.HF,
    name: 'Helmet Fund',
    description: 'Welfare and education support for soldiers and dependants.',
    displayOrder: 7,
  },
] as const;

export const ALL_FUND_CODES: readonly FundCode[] = FUND_DEFINITIONS.map((f) => f.code);
